<template>
    <div>

        <div class="sidebar sidebar-style-2">
			<div class="sidebar-wrapper scrollbar scrollbar-inner">
				<div class="sidebar-content">
					<div class="user">
						<div class="avatar-sm float-left mr-2">
							<img src="assets/img/profile.jpg" alt="..." class="avatar-img rounded-circle">
						</div>
						<div class="info">
							<a data-toggle="collapse" href="#collapseExample" aria-expanded="true">
								<span>
									<span class="user-level limit_huruf_nama">{{profile.nama}}</span>
									<span class="user-level">Administrator</span>
									<!-- <br>{{unit_kerja}} -->
									<span class="caret"></span>
								</span>
							</a>
							<div class="clearfix"></div>

							<div class="collapse in" id="collapseExample">
								<ul class="nav">
									<li>
										<a href="#profile">
											<span class="link-collapse">My Profile</span>
										</a>
									</li>

								</ul>
							</div>
						</div>
					</div>
					<ul class="nav nav-primary">
                        <li class="nav-item active">
                            <router-link to="/">
                                <i class="fas">
                                    <img src="assets/img/sf/house.svg" height="24" width="24">
                                </i>
								<p>Home</p>
                            </router-link>

						</li>

						<li class="nav-section">
							<span class="sidebar-mini-icon">
								<i class="fa fa-ellipsis-h"></i>
							</span>
							<h4 class="text-section">Components</h4>
						</li>
						<li class="nav-item" v-if="administrator">
							<a data-toggle="collapse" href="#Filtering_gberanda">
								<i class="fas"><img src="assets/img/sf/layers.svg" height="24" width="24"></i>
								<p ><b>Filtering Beranda</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="Filtering_gberanda">
								<ul class="nav nav-collapse">
									<li>
										<router-link to="/filter_berita">
											<span class="sub-item">Filter Berita</span>
										</router-link>
									</li>
									<li>
										<router-link to="/filter_foto">
											<span class="sub-item">Filter Foto Kegiatan</span>
										</router-link>
									</li>
									<li>
										<router-link to="/filter_berita">
											<span class="sub-item">Filter Video Kegiatan</span>
										</router-link>
									</li>
								</ul>
							</div>
						</li>
						<li class="nav-item">
                            <router-link to="/berita">
                                <i class="fas"><img src="assets/img/sf/news.svg" height="24" width="24"></i>
								<p><b>Berita</b></p>
							</router-link>
						</li>
						<li class="nav-item" v-if="administrator">
                            <router-link to="/about">
                                <i class="fas"><img src="assets/img/sf/institution.svg" height="24" width="24"></i>
								<p><b>E-Goverment</b></p>
							</router-link>
						</li>
						<li class="nav-item">
                            <router-link to="/link_terkait">
                                <i class="fas"><img src="assets/img/sf/file-link.svg" height="24" width="24"></i>
								<p><b>Link-Terkait</b></p>
							</router-link>
						</li>

						<li class="nav-item" v-if="administrator">
							<a data-toggle="collapse" href="#Profil">
								<i class="fas"><img src="assets/img/sf/folder-document.svg" height="24" width="24"></i>
								<p ><b>Profil</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="Profil">
								<ul class="nav nav-collapse">
									<li>
										<a data-toggle="collapse" href="#profil_daerah">
											<span class="sub-item">Profil Daerah</span>
											<span class="caret"></span>
										</a>
										<div class="collapse" id="profil_daerah">
											<ul class="nav nav-collapse subnav">
												<li>
													<router-link to="/profil_kabupaten">
														<span class="sub-item">Profil Kabupaten</span>
													</router-link>
												</li>
												<li>
													<router-link to="/profil_sejarah">
														<span class="sub-item">Sejarah </span>
													</router-link>
												</li>
												<li>
													<router-link to="/profil_kependudukan">
														<span class="sub-item">Kependudukan </span>
													</router-link>
												</li>
											</ul>
										</div>
									</li>

									<li>
										<a data-toggle="collapse" href="#profil_kepegawaian">
											<span class="sub-item">Profil Kepegawaian</span>
											<span class="caret"></span>
										</a>
										<div class="collapse" id="profil_kepegawaian">
											<ul class="nav nav-collapse subnav">
												<li>
													<router-link to="/profil_bupati">
														<span class="sub-item">Profil Bupati</span>
													</router-link>
												</li>
												<li>
													<router-link to="/profil_wabup">
														<span class="sub-item">Profil Wakil Bupati</span>
													</router-link>
												</li>
												<li>
													<router-link to="/profil_sekda">
														<span class="sub-item">Profil Sekda </span>
													</router-link>
												</li>
											</ul>
										</div>
									</li>
									<li>
										<router-link to="/profil_program_capaian">
											<span class="sub-item">List Pembangunan</span>
										</router-link>
									</li>
								</ul>
							</div>
						</li>

						<li class="nav-item" v-if="administrator">
							<a data-toggle="collapse" href="#Agenda_dan_pengumuman">
								<i class="fas"><img src="assets/img/sf/calendar-clock.svg" height="24" width="24"></i>
								<p ><b>Agenda/Pengumuman</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="Agenda_dan_pengumuman">
								<ul class="nav nav-collapse">
									<li>
										<router-link to="/agenda">
											<span class="sub-item">Agenda</span>
										</router-link>
									</li>
									<li>
										<router-link to="/pengumuman">
											<span class="sub-item">Pengumuman</span>
										</router-link>
									</li>

								</ul>
							</div>
						</li>
						
						<li class="nav-item" v-if="administrator">
							<a data-toggle="collapse" href="#Gallery">
								<i class="fas"><img src="assets/img/sf/device-camera.svg" height="24" width="24"></i>
								<p ><b>Gallery</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="Gallery">
								<ul class="nav nav-collapse">
									<li>
										<router-link to="/gallery_foto">
											<span class="sub-item">Foto</span>
										</router-link>
									</li>
									<li>
										<router-link to="/gallery_video">
											<span class="sub-item">Video</span>
										</router-link>
									</li>

								</ul>
							</div>
						</li>
						<li class="nav-item" v-if="administrator">
							<a data-toggle="collapse" href="#MTQ">
								<i class="fas"><img src="assets/img/sf/mosque_1.svg" height="24" width="24"></i>
								<p ><b>EVENT MTQ</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="MTQ">
								<ul class="nav nav-collapse">
									<li>
										<router-link to="/events_mtq_dokumen">
											<span class="sub-item">Dokumen</span>
										</router-link>
									</li>
								</ul>
							</div>
						</li>						

						<li class="mx-4 mt-2">
							<a class="btn btn-primary btn-block" @click="logout()">
								<span class="btn-label mr-2"><i class="fas"><img src="assets/img/sf/lock.svg" height="24" width="24"></i></span>
								Keluar
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
    </div>
</template>

<script>

    export default {
        name: 'monev_left_sidebar',
        data () {
            return {
                user: "",
                profile : {
					nama : '',
					nip : '',
				},
				administrator : false,
				unit_kerja : '',

                // inilah : this.$session.get('MENU')

            }
        },
        methods : {
            logout : function(){
                localStorage.removeItem('token');
                localStorage.removeItem('profile');
                this.$router.push('/login');
            },

            get_user : function(){
                fetch(URL_APP, {
                    headers: {
                        authorization: "kikensbatara " + localStorage.token
                }
                }).then(res => res.json())
                .then(result => {
                    if (result.user) {
                    this.user = result.user;
                    this.profile = result.user.profile;
                    localStorage.profile = JSON.stringify(result.user);
                    // console.log(localStorage.profile);

                    } else {
                        this.logout();
                    }
                });
            },


        },
        mounted: function(){
            var get_profile = JSON.parse(localStorage.profile);
            this.profile.nama = get_profile.profile.nama;
			this.profile.nip = get_profile.profile.ref_instansi;
			this.unit_kerja = get_profile.profile.unit_kerja;


			var lev_administrator = get_profile.profile.Berita;



			if (lev_administrator == '1') {
				this.administrator = true;
			} else {
				this.administrator = false;
			}


        },


    }
</script>